import { SelectOption } from "../../../../../components/newUI/select";
import { SelectOptionType } from "../../../../../types/types";

export const DEFAULT_PHONE_TYPE: SelectOption = {
  value: "bcd697a8-ef4c-4f91-bb8f-891df1ddfba0",
  label: "Mobile",
};

export const DEFAULT_ADDRESS_TYPE = "12F73C73-89E5-4F69-9F14-ED7A1FFC3080";

export const ADDRESS_TYPES: SelectOption[] = [
  {
    label: "Billing address",
    value: DEFAULT_ADDRESS_TYPE,
  },
  {
    label: "Shipping address",
    value: "3DD3A326-09C5-4E0A-93FC-6B439A4B6CAC",
  },
];

export const PRIMARY_EMAIL_TOOLTIP_ID = "organization-primary-email-tooltip";

export enum MonthsEnum {
  January = "January",
  February = "February",
  March = "March",
  April = "April",
  May = "May",
  June = "June",
  July = "July",
  August = "August",
  September = "September",
  October = "October",
  November = "November",
  December = "December",
}

export const monthsOptions: SelectOptionType[] = [
  { value: MonthsEnum.January, label: MonthsEnum.January },
  { value: MonthsEnum.February, label: MonthsEnum.February },
  { value: MonthsEnum.March, label: MonthsEnum.March },
  { value: MonthsEnum.April, label: MonthsEnum.April },
  { value: MonthsEnum.May, label: MonthsEnum.May },
  { value: MonthsEnum.June, label: MonthsEnum.June },
  { value: MonthsEnum.July, label: MonthsEnum.July },
  { value: MonthsEnum.August, label: MonthsEnum.August },
  { value: MonthsEnum.September, label: MonthsEnum.September },
  { value: MonthsEnum.October, label: MonthsEnum.October },
  { value: MonthsEnum.November, label: MonthsEnum.November },
  { value: MonthsEnum.December, label: MonthsEnum.December },
];

export const getDaysOptions = (month: MonthsEnum): SelectOptionType[] => {
  if (month === MonthsEnum.February) {
    return Array.from({ length: 29 }, (_, i) => ({
      label: i.toString(),
      value: i.toString(),
    }));
  }
  if (
    month === MonthsEnum.January ||
    month === MonthsEnum.March ||
    month === MonthsEnum.May ||
    month === MonthsEnum.July ||
    month === MonthsEnum.August ||
    month === MonthsEnum.October ||
    month === MonthsEnum.December
  ) {
    return Array.from({ length: 32 }, (_, i) => ({
      label: i.toString(),
      value: i.toString(),
    }));
  }

  return Array.from({ length: 31 }, (_, i) => ({
    label: i.toString(),
    value: i.toString(),
  }));
};
